var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapsule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "u:capsule"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4982 4.50002C18.5381 3.54007 17.2359 3.00079 15.8782 3.00079C14.5205 3.00079 13.2184 3.54007 12.2582 4.50002L4.49823 12.26C4.01138 12.7328 3.62338 13.2977 3.35681 13.9219C3.09024 14.546 2.95041 15.2169 2.94545 15.8955C2.94049 16.5742 3.0705 17.247 3.32792 17.875C3.58534 18.5029 3.96504 19.0734 4.44493 19.5533C4.92481 20.0332 5.49532 20.4129 6.12327 20.6703C6.75122 20.9277 7.42408 21.0578 8.10273 21.0528C8.78138 21.0478 9.45227 20.908 10.0764 20.6414C10.7005 20.3749 11.2654 19.9869 11.7382 19.5L19.4982 11.74C20.4582 10.7799 20.9975 9.47774 20.9975 8.12002C20.9975 6.7623 20.4582 5.46017 19.4982 4.50002ZM10.3182 18.09C9.72226 18.6533 8.93329 18.9672 8.11323 18.9672C7.29316 18.9672 6.5042 18.6533 5.90823 18.09C5.32627 17.5037 4.99969 16.7111 4.99969 15.885C4.99969 15.0589 5.32627 14.2663 5.90823 13.68L9.08823 10.5L13.4982 14.91L10.3182 18.09ZM18.0882 10.32L14.9082 13.5L10.4982 9.09002L13.6782 5.91002C14.2693 5.35634 15.0524 5.05417 15.8622 5.06737C16.6719 5.08058 17.4448 5.40813 18.0175 5.98078C18.5901 6.55344 18.9177 7.32633 18.9309 8.13608C18.9441 8.94584 18.6419 9.72899 18.0882 10.32Z",
    fill: "#250044"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapsule);
export default __webpack_public_path__ + "static/media/capsule.203c2ecfb39af5c33a1387a793b3b0b9.svg";
export { ForwardRef as ReactComponent };